require('./areas-edit-container.scss')

module.exports = {
  template: require('./areas-edit-container.pug')()
  controller: require('./areas-edit-container.ctrl')
  bindings:
    country: '<'
    city: '<'
}
